"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceCodec = exports.LayerCodec = exports.AnimationCodec = exports.AnimationRefCodec = exports.LayerRefCodec = void 0;
const lib_1 = require("@reality/euclid/lib");
const t = __importStar(require("io-ts"));
exports.LayerRefCodec = t.type({
    resourceID: t.string,
    layerID: t.string,
});
exports.AnimationRefCodec = t.type({
    resourceID: t.string,
    animationID: t.string,
});
exports.AnimationCodec = t.intersection([
    exports.AnimationRefCodec,
    t.type({
        length: t.number,
        frames: t.array(t.array(exports.LayerRefCodec)),
    }),
    t.partial({
        startingDisplacement: lib_1.CoordinateCodec,
        endingDisplacement: lib_1.CoordinateCodec,
    }),
]);
exports.LayerCodec = t.intersection([
    exports.LayerRefCodec,
    t.type({
        sprite: lib_1.CoordinateCodec,
    }),
    t.partial({
        size: t.type({
            width: t.number,
            height: t.number,
        }),
        animations: t.record(t.string, exports.AnimationCodec),
    }),
]);
exports.ResourceCodec = t.intersection([
    t.type({
        resourceID: t.string,
        url: t.string,
        spriteSize: t.number,
        layers: t.record(t.string, exports.LayerCodec),
    }),
    t.partial({
        meta: t.partial({
            spritesheetWidth: t.number,
            spritesheetHeight: t.number,
        }),
    }),
]);
//# sourceMappingURL=Resource.js.map